import { DropdownStyleView } from '../../../../../../features/dropdown-style-view/dropdown-style-view';
import s from './statements-controls.module.css';

export const StatementsControls = () => {
  return (
    <div className={s.feature}>
      <DropdownStyleView />
    </div>
  );
};
